export default __webpack_public_path__ + "static/member5-eca48e3d40b4c1cb67d208e3b2003d51.jpg";